import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";
import { IClassroom } from "../types/IClassroom";
import { IClassroomLearners } from "../types/IClassroomLearners";

export interface IClassroomLearnersMutationParameters {
    classroom: RelationalValue<IClassroom>;
    learners: IClassroomLearners[];
}

export type IClassroomLearnersMutationResult = IClassroom;

export const classroomLearnersMutation: IApiMutationFunction<IClassroomLearnersMutationParameters> = ({
    classroom,
    learners,
}) => {
    return {
        method: "PATCH",
        url: `/classrooms/${mapRelationalValue(classroom)}/learners`,
        data: {
            learners,
        },
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
    };
};

export const useClassroomLearnersMutation = createApiMutationHook<
    IClassroomLearnersMutationParameters,
    IClassroomLearnersMutationResult
>(classroomLearnersMutation);
